<template>
  <div class="Beneficiary-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-sold-out"></i> Beneficiaries</span>
      </div>
      <data-tables 
        v-loading="loading" 
        :data="dataBeneficiaryTable" 
        border 
        :page-size="10"
        :pagination-props="{ background: true, pageSizes: [10, 20, 50, 100] }">
        <el-table-column prop="type" label="Type" header-align="center" align="center" fixed></el-table-column>
        <el-table-column prop="currency" label="Currency" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.currency.toUpperCase() }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountnumber" label="Account number" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sortcode" label="Sortcode" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bic" label="BIC" header-align="center" align="center"></el-table-column>
        <el-table-column prop="iban" label="IBAN" header-align="center" align="center"></el-table-column>
        <el-table-column prop="beneficiary_id" label="Action" header-align="center" align="center" width="200">
          <template slot-scope="scope">

              <el-button icon="el-icon-edit" type="warning" size="mini" @click="getBeneficiaryToEdit(scope.row.beneficiary_id)">Edit</el-button>
              <el-button icon="el-icon-delete" type="danger" size="mini" @click="deleteBeneficiary(scope.row.beneficiary_id)">Del</el-button>

          </template>
        </el-table-column>
      </data-tables>
    </el-card>

    <BeneficiaryCompanyForm ref="BeneficiaryCompanyForm" v-if="formEditType === 'company'" v-on:on-submited="submited"/>
    <BeneficiaryPersonForm ref="BeneficiaryPersonForm"  v-if="formEditType === 'person'" v-on:on-submited="submited"/>
  </div>
</template>

<script>
import BeneficiaryCompanyForm from './company-form'
import BeneficiaryPersonForm from './person-form'
import {getBeneficiaryByCustomer, getBeneficiaryBy, delBeneficiary} from '@/api/beneficiary'
export default {
  components:{
    BeneficiaryCompanyForm,
    BeneficiaryPersonForm
  },
  props:{
    customerUID: String
  },
  data(){
    return{
      loading:false,
      dialogFormVisible: false,
      beneficiaryEditID: '',
      dataBeneficiaryTable: [],
      formEditType: "",
    }
  },
  methods:{
    getBeneficiaryData(){
      this.loading = true
      getBeneficiaryByCustomer(this.customerUID).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataBeneficiaryTable = data
        }
      })
    },
    getBeneficiaryToEdit(beneficiary_id){
      const loading = this.$notifyloading("Loading data...");
      getBeneficiaryBy(beneficiary_id).then(({ result, data }) => {
        loading.close();
        if (result) {
           this.formEditType = data.type
          setTimeout(()=>{
            this.formEditType === "company" && this.$refs.BeneficiaryCompanyForm.setModel(beneficiary_id, data);
            this.formEditType === "person" && this.$refs.BeneficiaryPersonForm.setModel(beneficiary_id, data);
          }, 400)
          
        }
      });
    },
    deleteBeneficiary(beneficiary_id){
            this.$confirm('Are you sure you want to delete this Beneficiary, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          delBeneficiary(beneficiary_id).then(({ result, message}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete Beneficiary successfully`,
                type: 'success',
                duration: 2000
              });
              this.getBeneficiaryData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
    submited(){
      this.getBeneficiaryData()
    }
  },
  created(){
    this.getBeneficiaryData()
  }
}
</script>

<style>

</style>